import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { JobScreenTaskTimesTask } from '../../../../interfaces/screen-specific/job-screen';
import { TaskService } from '../../../../services';
import { computed } from 'mobx-angular';
import { IVehicleAddress } from '../../../../interfaces/task-info';

@Component({
  selector: 'job-screen-customer-task-window',
  templateUrl: './job-screen-customer-task-window.component.html',
  styleUrls: ['./job-screen-customer-task-window.component.scss'],
  providers: [DatePipe],
})
export class JobScreenCustomerTaskWindowComponent implements OnChanges {
  @Input() taskId: number;

  task: JobScreenTaskTimesTask;
  loading: boolean = false;

  @computed
  public get pickupLocation(): IVehicleAddress {
    return this.task?.pickupLocation;
  }

  @computed
  public get dropoffLocation(): IVehicleAddress {
    return this.task?.dropoffLocation;
  }

  @computed
  public get pickupEarliestDateTime(): Date | null {
    return this.task?.pickupEarliestDateTime ? new Date(this.task.pickupEarliestDateTime) : null;
  }

  @computed
  public get pickupLatestDateTime(): Date | null {
    return this.task?.pickupLatestDateTime ? new Date(this.task.pickupLatestDateTime) : null;
  }

  @computed
  public get dropoffEarliestDateTime(): Date | null {
    return this.task?.dropoffEarliestDateTime ? new Date(this.task.dropoffEarliestDateTime) : null;
  }

  @computed
  public get dropoffLatestDateTime(): Date | null {
    return this.task?.dropoffLatestDateTime ? new Date(this.task.dropoffLatestDateTime) : null;
  }

  constructor(public taskService: TaskService, private datePipe: DatePipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskId && this.taskId != null) {
      void this.getTaskTimes();
    }
  }

  async getTaskTimes() {
    try {
      this.task = null;
      this.loading = true;
      this.task = await this.taskService.getForComponent<JobScreenTaskTimesTask>(
        this.taskId,
        'job-screen-task-times-customer-windows',
      );
    } finally {
      this.loading = false;
    }
  }

  public formatAddress(location: IVehicleAddress): string {
    if (!location) return '';
    const addressParts = [location.businessName, location.city, location.postcode].filter(Boolean);
    return addressParts.join(', ');
  }

  public formatDateRange(earliest: Date, latest: Date): string {
    if (!earliest || !latest) return '';

    const isSameDay = earliest.toDateString() === latest.toDateString();

    if (isSameDay) {
      const start = this.datePipe.transform(earliest, 'MMM d, h:mm a');
      const end = this.datePipe.transform(latest, 'h:mm a');
      return `${start} - ${end}`;
    } else {
      const start = this.datePipe.transform(earliest, 'MMM d, h:mm a');
      const end = this.datePipe.transform(latest, 'MMM d, h:mm a');
      return `${start} - ${end}`;
    }
  }
}
